import { FC, useState } from "react";
import Modal from "components/Modal";
import { CreateTicketForm } from "features/create-ticket";
import { formStyles } from "shared/ui";
import { TicketsList } from "./TicketsList";

import styles from "./SupportTicketsModal.module.css";

interface Props {
  // Скрывает модалку, не сбрасывая состояние (например, пока открыт тред).
  isOpen?: boolean;
  onClose: () => void;
  onOpenTicket: (ticketId: number) => void;
}

export const SupportTicketsModal: FC<Props> = ({
  isOpen = true,
  onClose,
  onOpenTicket,
}) => {
  const [isCreating, setIsCreating] = useState(false);
  const toggleButtonClass = `${formStyles.outlineButton} ${formStyles.accent}`;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isCreating ? "New request" : "My requests"}
      className={styles.modal}
    >
      <div className={styles.content}>
        <button
          type="button"
          className={`${toggleButtonClass} ${styles.toggle}`}
          onClick={() => setIsCreating((prev) => !prev)}
        >
          {isCreating ? "Back to requests" : "New request"}
        </button>
        {isCreating ? (
          <CreateTicketForm onCreated={() => setIsCreating(false)} />
        ) : (
          <TicketsList onOpenTicket={onOpenTicket} />
        )}
      </div>
    </Modal>
  );
};
